export const ALL_BRANDS_LABEL = 'All brands';
